import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LpnDiscountLetterSchoolSchema = withDefaults({
  type: 'lpn-discount-letter-school',
  fields: [
    {
      kind: 'attribute',
      name: 'schoolName',
    },
    {
      kind: 'attribute',
      name: 'institutionIdentifier',
    },
  ],
});

export default LpnDiscountLetterSchoolSchema;
